import { useMutation } from '@tanstack/react-query';
import { METABASE_API_URL, metabaseApi } from '../../core/api';

interface CreateCardProps {
  name: string;
  description: string | null;
  display: string;
  collection_position?: number | null;
  result_metadata?: unknown[] | null;
  collection_id: number;
  visualization_settings: unknown;
  dataset_query: unknown;
}

export const useCreateCard = () => {
  return useMutation({
    mutationFn: async (payload: CreateCardProps) => {
      const response = await metabaseApi.post(
        `${METABASE_API_URL}/card`,
        payload
      );
      return response;
    },
  });
};
